import { Controller } from '@hotwired/stimulus';
import { mask } from './doc';

// The document field, wearing doc.js — the same mask Doc.mask prints, so the
// field and the model agree on what a document looks like. A CPF grows its
// dots, turns CNPJ on the twelfth character, and anything else (a passport,
// a CNS, another country's id) stays as typed. The form builder puts it only
// on a holder whose country has a CPF (docs/ADDRESS.md § The document).
//
//   <input data-controller="doc-input">
export default class extends Controller {
  // A document is stored as its digits; the field shows it the way it is read.
  connect() {
    this.element.value = mask(this.element.value);
    this.element.addEventListener('input', this.format);
  }

  disconnect() {
    this.element.removeEventListener('input', this.format);
  }

  // Typing at the end, the cursor follows; in the middle, it stays where it
  // was plus whatever the mask added.
  format = () => {
    const el = this.element;
    const before = el.selectionStart;
    const length = el.value.length;
    el.value = mask(el.value);
    if (before !== null) {
      const after = before + (el.value.length - length);
      el.setSelectionRange(after, after);
    }
  };
}
